import { render, staticRenderFns } from "./CaptionView.vue?vue&type=template&id=cc4fa9c2&"
import script from "./CaptionView.vue?vue&type=script&lang=js&"
export * from "./CaptionView.vue?vue&type=script&lang=js&"
import style0 from "./CaptionView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports